import ArticleWall from './articleWall'

const wallWrapper = document.getElementById('articleWall')

if (wallWrapper) {
	const articleWall = new ArticleWall()
	articleWall.init()
}
